/* Buckle / clasp drawer: simple view first. HEllO EDC, 21 Oct 2026.

   The drawer used to open straight onto every choice: Buckles/Clasps tabs,
   type, colour, finish. Most shoppers keep the standard buckle, and someone
   new to straps meets a decision they never asked for. Now it opens on what
   the strap comes with:

     YOUR STRAP COMES FITTED WITH
     Slim Dress Tang Buckle
     Silver · Brushed · Included in the price
     Sized for your strap: 18mm at the buckle end
     [ CUSTOMISE YOUR BUCKLE / CLASP > ]          [photo]  ₹1,950  [CONFIRM THIS BUCKLE]

   One tap confirms the standard piece. "Customise" reveals the full chooser,
   unchanged, for the rest of the visit to this page.

   An add-on to assets/wc-buckle.js, which is not modified. It reads what
   wc-buckle.js publishes (window.WCBuckle, the wc-buckle:change event) and
   the config JSON it reads, and only adds a class and one block to the
   panel. If this file fails, the drawer is exactly as it was. */

(function () {
  'use strict';

  if (window.__wcBuckleSimple) return;
  window.__wcBuckleSimple = true;

  var custom = false;
  var cfg = null;
  var byId = {};

  function readCfg() {
    if (cfg) return cfg;
    var el = document.querySelector('[data-wc-buckle-data]');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return null; }
    (cfg.families || []).forEach(function (f) {
      (f.vs || []).forEach(function (v) { byId[v.id] = { fam: f, v: v }; });
    });
    return cfg;
  }

  function money(cents) {
    var f = (cfg && cfg.moneyFormat) || '₹{{amount}}';
    var v = (cents / 100).toFixed(2);
    if (f.indexOf('amount_no_decimals') > -1) v = Math.round(cents / 100).toString();
    var sym = (f.match(/^[^{]*/) || [''])[0].replace(/&[^;]+;/g, '').trim();
    return (sym || '₹') + v;
  }

  function setText(el, txt) {
    if (el && el.textContent !== txt) el.textContent = txt;
  }

  function isClasp(hit, B) {
    var k = String((hit && hit.fam.kind) || '').toLowerCase();
    if (k) return k.indexOf('clasp') > -1;
    return /clasp/i.test((B && B.componentTitle) || '');
  }

  function panel() { return document.querySelector('[data-wc-panel]'); }

  function build(p) {
    if (p.querySelector('[data-wcs-quick]')) return;
    var main = p.querySelector('.wc-main');
    if (!main) return;
    var q = document.createElement('div');
    q.className = 'wc-quick';
    q.setAttribute('data-wcs-quick', '');
    q.innerHTML =
      '<p class="wc-quick__lead" data-wcs-lead></p>' +
      '<p class="wc-quick__name" data-wcs-name></p>' +
      '<p class="wc-quick__meta" data-wcs-meta></p>' +
      '<p class="wc-quick__fit" data-wcs-fit></p>' +
      '<button type="button" class="wc-customise" data-wcs-customise>' +
        '<span>Customise your buckle / clasp</span>' +
        '<svg viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M3.5 2l3 3-3 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    main.insertBefore(q, main.firstChild);
  }

  function simpleOn(p) { return !!p && p.classList.contains('wc-panel--simple'); }

  function relabel() {
    var p = panel();
    var btn = p && p.querySelector('[data-wc-done]');
    if (!btn) return;
    var B = window.WCBuckle;
    var noun = isClasp(B && byId[B.componentVariantId], B) ? 'clasp' : 'buckle';
    if (simpleOn(p) && btn.textContent === 'Done') setText(btn, 'Confirm this ' + noun);
    else if (!simpleOn(p) && /^Confirm this /.test(btn.textContent)) setText(btn, 'Done');
  }

  function paint() {
    var p = panel();
    if (!p || !readCfg()) return;
    build(p);

    var B = window.WCBuckle;
    var id = B && B.componentVariantId;
    var simple = !custom && !!id;
    if (simpleOn(p) !== simple) p.classList.toggle('wc-panel--simple', simple);
    if (!simple) { relabel(); return; }

    var hit = byId[id] || null;
    var title = (B && B.componentTitle) || (hit && hit.fam.title) || '';
    var noun = isClasp(hit, B) ? 'clasp' : 'buckle';
    var lug = B && B.lug;
    var wanted = (lug != null && cfg.overrides && cfg.overrides[String(lug)]) || cfg.defaultHandle;
    var standard = !hit || hit.fam.handle === wanted;

    setText(p.querySelector('[data-wcs-lead]'), standard
      ? 'Your strap comes fitted with'
      : 'Our standard buckle is out of stock in this size, so we fit');
    setText(p.querySelector('[data-wcs-name]'), title);

    var bits = hit ? [hit.v.colour, hit.v.finish].filter(Boolean) : [];
    var price = (B && B.componentPrice) || 0;
    bits.push(price > 0 ? '+' + money(price) : 'Included in the price');
    if (B && B.componentAvailable === false) bits.push('Out of stock');
    setText(p.querySelector('[data-wcs-meta]'), bits.join(' · '));

    var t = B && B.taper;
    setText(p.querySelector('[data-wcs-fit]'), t ? 'Sized for your strap: ' + t + 'mm at the ' + noun + ' end' : '');

    relabel();
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-wcs-customise]');
    if (!b) return;
    e.preventDefault();
    custom = true;
    paint();
  });

  document.addEventListener('wc-buckle:change', paint);

  /* For the "Customise my strap" window (wc-customise.js): a shopper who
     asked to customise goes straight to the full chooser. */
  window.WCBuckleSimple = { customise: function () { custom = true; paint(); } };

  function start() {
    paint();
    /* The panel can be mounted (or re-mounted) after this runs, and
       wc-buckle.js repaints the Done button's label on every render. */
    var root = document.querySelector('product-info') || document.body;
    if (window.MutationObserver && root) {
      new MutationObserver(function () {
        var p = panel();
        if (!p) return;
        if (!p.querySelector('[data-wcs-quick]')) paint();
        else relabel();
      }).observe(root, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
